import React, { ReactNodeArray, ReactNode } from "react";
import styled from "@emotion/styled";

interface DescriptionProps {
  label?: string;
  children: ReactNodeArray | ReactNode;
  secondary?: boolean;
}

const StyledColumn = styled.div`
  padding-bottom: 1rem;
`;

const StyledLabel = styled.label`
  &:after {
    display: inline-block;
    content: ":";
    padding-right: 0.4rem;
  }
`;

const StyledFreeText = styled.span`
  white-space: pre-line;
`;

export const Description = ({ label, children }: DescriptionProps) => {
  return (
    <div className="row">
      <StyledColumn className={label ? "col-xs-12" : "col-xs-12"}>
        {label && <StyledLabel>{label}</StyledLabel>}
        <StyledFreeText>
          {children ? children : "Information not available"}
        </StyledFreeText>
      </StyledColumn>
    </div>
  );
};
